import type { DeepRequired } from '../fixtures.types'

const kbaChoice: DeepRequired<KbaChoice> = {
  __typename: 'KbaChoice',
  id: 'TEST_ID',
  text: '',
}

export default kbaChoice
